import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  FaCheckCircle,
  FaTimesCircle,
  FaArrowRight,
  FaHome,
} from "react-icons/fa";
import { verifyEmail } from "../../store/slices/auth/asyncThunks";
import { useTheme } from "../../contexts/ThemeContext";
import { toast } from "../../components/modern-ui/sonner";
import {
  MainContainer,
  ContentCard,
  IconContainer,
  Title,
  Text,
  ButtonContainer,
  ActionButton,
  SecondaryButton,
  LoadingContainer,
  LoadingSpinner,
  LoadingText,
} from "./VerifyEmailPage.styles";

const VerifyEmailPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { theme } = useTheme();
  const { tokenId } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (tokenId) {
      setLoading(true);
      dispatch(verifyEmail({ code: tokenId }))
        .unwrap()
        .then(() => {
          setError(false);
          setLoading(false);
          toast.success("Email verified successfully!");
        })
        .catch((err) => {
          setError(true);
          setLoading(false);
          toast.error(err.message || "Failed to verify email");
        });
    } else {
      setError(true);
      setLoading(false);
    }
  }, [dispatch, tokenId]);

  const handleContinue = () => {
    navigate("/");
  };

  const handleTryAgain = () => {
    window.location.reload();
  };

  const handleGoHome = () => {
    navigate("/");
    localStorage.setItem("activeTabIndex", "0");
  };

  return (
    <MainContainer theme={theme}>
      <ContentCard theme={theme}>
        {loading ? (
          <LoadingContainer>
            <LoadingSpinner theme={theme} />
            <LoadingText theme={theme}>Verifying your email...</LoadingText>
          </LoadingContainer>
        ) : error ? (
          <>
            <IconContainer $success={false} theme={theme}>
              <FaTimesCircle />
            </IconContainer>
            <Title theme={theme}>Verification Failed</Title>
            <Text theme={theme}>
              We couldn't verify your email address. The verification link may
              be invalid or expired.
            </Text>
            <ButtonContainer>
              <ActionButton onClick={handleTryAgain}>
                <FaArrowRight />
                Try Again
              </ActionButton>
              <SecondaryButton theme={theme} onClick={handleGoHome}>
                <FaHome />
                Go Home
              </SecondaryButton>
            </ButtonContainer>
          </>
        ) : (
          <>
            <IconContainer $success={true} theme={theme}>
              <FaCheckCircle />
            </IconContainer>
            <Title theme={theme}>Email Verified!</Title>
            <Text theme={theme}>
              Your email address has been successfully verified. You can now
              access all features of your account.
            </Text>
            <ButtonContainer>
              <ActionButton onClick={handleContinue}>
                <FaArrowRight />
                Continue
              </ActionButton>
            </ButtonContainer>
          </>
        )}
      </ContentCard>
    </MainContainer>
  );
};

export default VerifyEmailPage;
